import { isEmpty } from "@grindex-client/common/js/helpers/typeHelpers";
import { xylemStorage } from "@grindex-client/components/SessionStorage/xylemStorage";

/**
 * Fetch getCurrentPosition for a user. Will try get it from sessionStorage.
 * If not set then it takes HTML5 geoLocation and set sessionStorage
 * @param {(...args: unknown[]) => void} callback A callback function for success
 * @param {function} errorCallback A callback function for errors
 * @param {PositionOptions} options Options passed to HTML5 getCurrentPosition()
 */
function getCurrentPosition(callback, errorCallback, options) {
	if (typeof callback !== "function") {
		console.warn("No callback function set for getCurrentPosition");
		return;
	}
	if (!navigator.geolocation) {
		if (typeof errorCallback === "function") {
			errorCallback({ code: 500, message: "Browser not supported" });
		}
		return;
	}
	const sessionLocation = xylemStorage.getCurrentSessionStorage("geo.location");
	if (window.sessionStorage && !isEmpty(sessionLocation)) {
		callback(sessionLocation);
		return;
	} else {
		// Browser geolocation fetch
		navigator.geolocation.getCurrentPosition(
			function (pos) {
				const location = { latitude: pos.coords.latitude, longitude: pos.coords.longitude };
				if (window.sessionStorage) {
					xylemStorage.setCurrentSessionStorage("geo.location", location);
				}

				callback(location);
				return;
			},
			function (error) {
				if (typeof errorCallback === "function") {
					errorCallback(error);
					return;
				}
			},
			options,
		);
	}
}

export { getCurrentPosition };
